(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nbj-card-ai-hover"] && !Shopify.designMode) return;
  try {
    class NbjCardAiHover extends HTMLElement {
    #listeners;
    #hovered = false;
    #selected = false;
    #ready = false;
    #controls;
    #gesture = null;
    #ignoreClickUntil = 0;

    connectedCallback() {
      this.#listeners?.abort();
      this.#listeners = new AbortController();
      const card = this.closest('product-card, .nbj-product');
      const photo = this.closest('.card-gallery, .nbj-product-photo');
      if (!card || !photo) return;
      const options = { signal: this.#listeners.signal };
      card.addEventListener('pointerenter', this.#enter, options);
      card.addEventListener('pointerleave', this.#leave, options);
      card.addEventListener('pointerdown', this.#start, { ...options, capture: true, passive: true });
      document.addEventListener('pointermove', this.#move, { ...options, capture: true, passive: false });
      document.addEventListener('pointerup', this.#end, { ...options, capture: true });
      document.addEventListener('pointercancel', this.#cancel, options);
      card.addEventListener('click', this.#guardClick, { ...options, capture: true });
      this.#controls?.remove();
      this.#controls = this.querySelector('[data-nbj-preview-cue]')?.content.firstElementChild?.cloneNode(true);
      if (this.#controls) {
        photo.after(this.#controls);
        this.#controls.addEventListener('click', this.#choose, options);
      }
      const image = this.querySelector(':scope > img');
      this.#ready = Boolean(image?.complete && image.naturalWidth > 0);
      if (card.matches(':hover') && matchMedia('(hover: hover) and (pointer: fine)').matches) this.#enter();
      this.#sync();
    }

    disconnectedCallback() {
      this.#listeners?.abort();
      this.#controls?.remove();
      this.#controls = null;
      this.#gesture = null;
      this.#hovered = false;
      this.#selected = false;
      this.classList.remove('is-visible');
    }

    #load() {
      if (this.querySelector(':scope > img')) return;
      const source = this.querySelector('[data-nbj-preview-image]')?.content.querySelector('img');
      if (!source) return;
      const image = source.cloneNode(true);
      image.loading = 'eager';
      const loaded = () => {
        this.#ready = image.naturalWidth > 0;
        this.#sync();
      };
      image.addEventListener('load', loaded, { once: true, signal: this.#listeners.signal });
      image.addEventListener('error', () => {
        this.#ready = false;
        this.#selected = false;
        this.#hovered = false;
        if (this.#controls) this.#controls.hidden = true;
        this.#sync();
      }, { once: true, signal: this.#listeners.signal });
      this.append(image);
      if (image.complete && image.naturalWidth > 0) loaded();
    }

    #sync() {
      this.classList.toggle('is-visible', this.#ready && (this.#selected || this.#hovered));
      this.#controls?.querySelectorAll('[data-nbj-preview]').forEach((button) => {
        button.setAttribute('aria-pressed', String((button.dataset.nbjPreview === '1') === this.#selected));
      });
      const hint = this.#controls?.querySelector('.nbj-card-preview-hint');
      if (hint) hint.textContent = this.#selected ? this.#controls.dataset.originalHint : this.#controls.dataset.styledHint;
    }

    #show(selected) {
      this.#selected = selected;
      if (selected) this.#load();
      this.#sync();
    }

    #choose = (event) => {
      const button = event.target.closest('[data-nbj-preview]');
      if (!button) return;
      event.preventDefault();
      event.stopPropagation();
      this.#show(button.dataset.nbjPreview === '1');
    };

    #enter = (event) => {
      if (event && event.pointerType !== 'mouse') return;
      if (!matchMedia('(hover: hover) and (pointer: fine)').matches) return;
      this.#hovered = true;
      this.#load();
      this.#sync();
    };

    #leave = () => {
      this.#hovered = false;
      this.#sync();
    };

    #start = (event) => {
      if (event.pointerType !== 'touch' || !event.isPrimary) return;
      const photo = this.closest('.card-gallery, .nbj-product-photo');
      const rect = photo?.getBoundingClientRect();
      if (!rect || event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) return;
      this.#hovered = false;
      this.#gesture = { id: event.pointerId, x: event.clientX, y: event.clientY, horizontal: false };
    };

    #move = (event) => {
      const gesture = this.#gesture;
      if (!gesture || event.pointerId !== gesture.id) return;
      const dx = event.clientX - gesture.x;
      const dy = event.clientY - gesture.y;
      if (!gesture.horizontal) {
        if (Math.abs(dy) > 10 && Math.abs(dy) >= Math.abs(dx)) {
          this.#gesture = null;
          return;
        }
        if (Math.abs(dx) < 12 || Math.abs(dx) < Math.abs(dy) * 1.4) return;
        gesture.horizontal = true;
      }
      if (event.cancelable) event.preventDefault();
      event.stopPropagation();
    };

    #end = (event) => {
      const gesture = this.#gesture;
      if (!gesture || event.pointerId !== gesture.id) return;
      this.#gesture = null;
      const dx = event.clientX - gesture.x;
      const dy = event.clientY - gesture.y;
      if (!gesture.horizontal) return;
      this.#ignoreClickUntil = performance.now() + 500;
      if (Math.abs(dx) >= 32 && Math.abs(dx) > Math.abs(dy) * 1.4) this.#show(dx < 0);
    };

    #cancel = () => {
      this.#gesture = null;
    };

    #guardClick = (event) => {
      if (event.target.closest?.('.nbj-card-preview-cue, nbj-card-swatches, button, input, select')) return;
      if (performance.now() >= this.#ignoreClickUntil) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    };
  }

  if (!customElements.get('nbj-card-ai-hover')) {
    customElements.define('nbj-card-ai-hover', NbjCardAiHover);
  }
  } catch(e) { console.error(e); }
})();

})();
